export const splitHeaderText = (text: string) =>
  text
    .split(/(?:\r\n|\r|\n|\\n)/g)
    .join(' ↲ ')
    .replace(/  +/g, ' ')
    .split(' ');
